import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ENVIRONMENT_CONFIG, type EnvironmentConfig } from '@shared/config';

@Component({
  selector: 'pulse-page-not-found',
  templateUrl: './page-not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageNotFoundComponent {
  private config = inject<EnvironmentConfig>(ENVIRONMENT_CONFIG);
  supportEmailHref = `mailto:${this.config.supportEmailAddress}`;
}
